<template>
    <div class="t-lk-modal__content">
        <h2 class="t-lk-modal__title" v-html="$root.staticText.lk.missingDataTitle"></h2>

        <div v-if="props.moderateText" class="t-lk-missing-data__text" v-html="props.moderateText"></div>

        <form-dynamic-cmp
            v-else
            class="t-lk-modal__form t-lk-missing-data__form"
            :form-info="props.formInfo"
            :button="props.button"
            :class-white="false"
            :not-full="true"
            :lk-personal-data="true"
            :action="action"
            :check-error="true"
            :is-reload="true"
        >
        </form-dynamic-cmp>
    </div>
</template>

<script>
import VueRecaptcha from "vue-recaptcha";
import selectCustom from '@components/ui-components/select-custom/select-custom-dynamic.vue';
import {mapActions} from "vuex";
import formDynamic from '@components/base/form-dynamic.vue';

export default {
    name: "missing-data",
    props: ['props'],
    data() {
        return {
            action: "lk/partner/update",
            infoForm: {
                success: false,
                error: false,
            },
            errorTextForm: null,
        }
    },
    components: {
        VueRecaptcha,
        'select-custom-cmp': selectCustom,
        'form-dynamic-cmp': formDynamic,
    },
    watch: {
        'infoForm.success': function() {
            if (this.infoForm.success) {
                this.modalClose();
                this.modalType_successOpen({
                    title: this.$root.staticText.modal.successTitleFeedback,
                    text: this.$root.staticText.modal.successTextFeedback,
                    class: '_small'
                });
            }
        },
        'infoForm.error': function() {
            if (this.infoForm.error) {
                this.modalClose();
                this.modalType_errorOpen({
                    title: this.$root.staticText.modal.errorTitle,
                    text: this.errorTextForm ? this.errorTextForm : this.$root.staticText.modal.errorText,
                    class: '_small'
                });
            }
        }
    },
    methods: {
        ...mapActions('modal', ['modalType_successOpen', 'modalType_errorOpen', 'modalClose']),
    },
}
</script>



// WEBPACK FOOTER //
// src/templates/components/base/modals/missing-data.vue